import { gql } from '@grandvisionhq/graphql';
import NearestStoreFragment from '../fragments/nearest-store.js';

const GET_NEAREST_STORES = gql`
  query GetNearestStores(
    $searchGeoLocation: GeoLocationInput!
    $maxResults: Int
    $maxDistance: Int
    $filter: StoreFilter
    $forceDistance: Boolean
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      maxResults: $maxResults
      maxDistance: $maxDistance
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...NearestStore
    }
  }
  ${NearestStoreFragment}
`;

export { GET_NEAREST_STORES };
//# sourceMappingURL=get-nearest-stores.js.map
